import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

type Response = {
  is_connected: boolean;
};

const queryZoomIntegrationStatus = async (): Promise<Response> => {
  const res = await fetchOrchidAPI(`/api/users/v1/zoom/status`);
  if (!res.ok) {
    throw new Error(
      `failed to get zoom integration status: ${getErrorDetail(
        await res.text(),
      )}`,
    );
  }
  const responseData = await res.json();

  return responseData as Response;
};

export default queryZoomIntegrationStatus;
